function getHeight(elem) {
	return Math.max(
		elem.scrollHeight,
		elem.offsetHeight,
		elem.clientHeight,
	);
}

function changeHeight(el, height) {
	if (el.classList.contains('is-visible')) {
		el.style.height = `${height}px`;
	} else {
		el.style.height = 0;
	}
}

function toggleClass(dropdownBtn) {
	const dropdownContent = dropdownBtn.parentNode.querySelector('.dropdown-js-content');

	if (dropdownContent) {
		const contentHeight = getHeight(dropdownContent);

		dropdownBtn.classList.toggle('is-active');
		dropdownContent.classList.toggle('is-visible');

		changeHeight(dropdownContent, contentHeight);
	}
}

function init() {
	window.addEventListener('click', (e) => {
		const dropdownBtn = e.target.closest('.dropdown-js');

		if (dropdownBtn) {
			e.preventDefault();

			toggleClass(dropdownBtn);
		}
	});
}

export default {
	init,
};
